import React from 'react';
import PropTypes from 'prop-types';
import { Input, Checkbox } from 'react-toolbox';

function ProjectNeeds({
  needs,
  onChange,
  showDumpFee = true,
  showAdditionalMiles = true,
  permitRequired,
  onPermitRequiredChange,
}) {
  const handleFieldChange = (field, value) => {
    onChange({ ...needs, [field]: value });
  };

  return (
    <div>
      <Checkbox
        label="Permit Required"
        checked={!!permitRequired}
        onChange={onPermitRequiredChange}
      />
      {showDumpFee && (
        <Checkbox
          label="Dump Fee Needed"
          checked={!!needs.dumpFeeNeeded}
          onChange={v => handleFieldChange('dumpFeeNeeded', v)}
        />
      )}
      {showAdditionalMiles && (
        <Input
          label="Additional Miles Over 20"
          value={needs.additionalMilesOver20 || ''}
          onChange={v => handleFieldChange('additionalMilesOver20', v)}
        />
      )}
    </div>
  );
}

ProjectNeeds.propTypes = {
  needs: PropTypes.shape({
    dumpFeeNeeded: PropTypes.bool,
    additionalMilesOver20: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onChange: PropTypes.func.isRequired,
  showDumpFee: PropTypes.bool,
  showAdditionalMiles: PropTypes.bool,
  permitRequired: PropTypes.bool,
  onPermitRequiredChange: PropTypes.func,
};

export default ProjectNeeds;

export function validateProjectNeeds(needs) {
  const errors = {};
  const numberFields = [
    'additionalMilesOver20',
  ];
  let hasNumberError = false;
  numberFields.forEach((field) => {
    const value = needs[field];
    if (value !== undefined && value !== '' && isNaN(Number(value))) {
      errors[field] = [`${field} must be a number.`];
      hasNumberError = true;
    }
  });
  if (hasNumberError) {
    errors.numberFields = [
      'Please ensure all numeric fields are valid numbers.',
    ];
  }
  return errors;
}



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/ProjectNeeds.jsx